import { getMessages } from '../../../../../../../store/constants';

export const BOARD_NOTIFICATION_SCOPE_ALL = getMessages().getText('notification_settings__label_all');
export const BOARD_NOTIFICATION_SCOPE_ASSIGNED = getMessages().getText('notification_settings__label_assigned');
export const BOARD_NOTIFICATION_SCOPE_WATCH = getMessages().getText('notification_settings__label_watched_cards_updates');
